import { render, staticRenderFns } from "./adminTabParkAdd.vue?vue&type=template&id=65a231d0&"
import script from "./adminTabParkAdd.vue?vue&type=script&lang=ts&"
export * from "./adminTabParkAdd.vue?vue&type=script&lang=ts&"
import style0 from "./adminTabParkAdd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports